import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import UnsignedLeaseWarning from '@rental-manager/pages/Onboarding/RentalProtectionUnsignedLeaseWarning/component';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { pageFlows } from '@rental-manager/pages/Dashboard/SetupNewTermModal/pageFlows';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import { saveRentalProtectionFeature } from '@rental-manager/actions/OnboardingActions';
import { logError } from '@zg-rentals/log-error';
import { ToggleFeatureWebApiHandler_toggleFeature } from '@zg-rentals/ts-rent-payment-client';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => {
  const { rentalProtectionDisclaimers } = state.payments.landlord.onboarding[propertyId];
  return {
    propertyId,
    rentalProtectionDisclaimers,
  };
};

const mapDispatchToProps = (dispatch, { propertyId, baseUrl }) => ({
  skipRentalProtectionOnboarding: ({ featureName, on }) =>
    Promise.resolve()
      .then(() => ToggleFeatureWebApiHandler_toggleFeature({ resourceId: propertyId, featureName, on }))
      .then(() => dispatch(saveRentalProtectionFeature({ propertyId, rentGuarantee: false })))
      .then(() => dispatch(saveNewTermSettings({ currentPage: pageFlows.CurrentTenantEndDate })))
      .then(() => dispatch(push(baseUrl + paths.dashboard.setupNewTermPage)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnsignedLeaseWarning);
